import * as React from 'react';
import { IFeatureFlagPartnersTypeState, IFeatureFlagPartnersType } from './FeatureFlagPartnersTypes';
import { IChildrenProps } from 'types/children';
import { PartnerRelationshipTypeEnum } from 'enums/PartnerRelationshipType';

export const FeatureFlagPartnersContext = React.createContext<IFeatureFlagPartnersTypeState | null>(null);
const FeatureFlagPartnersProvider: React.FC<IChildrenProps> = ({ children }) => {
    /**
     * Initialize the state for feature flag partners, this state will hold the feature flag partners data
     * and provide a way to update it through the context.
     **/
    const initialState: IFeatureFlagPartnersType[] = [
        {
            label: '',
            distributorKey: '',
            loanServicerKey: '',
            partnerRelationType: undefined
        }
    ];
    const [stateFeatureFlagPartners, setStateFeatureFlagPartners] =
        React.useState<IFeatureFlagPartnersType[]>(initialState);
    const saveFeatureFlagPartnersState = (featureFlagPartnersData: IFeatureFlagPartnersType[]): void => {
        const newArray = featureFlagPartnersData.map((item) => ({
            label: item.label,
            distributorKey: item.distributorKey,
            loanServicerKey: item.loanServicerKey,
            partnerRelationType: item.loanServicerKey
                ? PartnerRelationshipTypeEnum.LoanServicer
                : PartnerRelationshipTypeEnum.Distributor
        }));
        setStateFeatureFlagPartners((prev) => newArray);
    };
    const stateObject: IFeatureFlagPartnersTypeState = {
        contextStateFeatureFlagPartners: stateFeatureFlagPartners,
        updateContextStateFeatureFlagPartners: saveFeatureFlagPartnersState
    };
    /*    console.info(
        '\n::::::::::::::::::::::::::::::FeatureFlagPartnersContext::updateContextStateFeatureFlagPartners:::::::::::::::::::::::::::::::::',
        '\n::stateFeatureFlagPartners::',
        stateFeatureFlagPartners,
        '\n:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::'
    );*/
    return <FeatureFlagPartnersContext.Provider value={stateObject}>{children}</FeatureFlagPartnersContext.Provider>;
};

export default FeatureFlagPartnersProvider;
